import { useRef } from "react";
import { IconButton } from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import { MobileAppModalBundleName as BundleName, CurrentBundleContainer as BundleContainer } from "../../MobileAppModal/MobileAppModal.style";
import { BundleLink, ButtonCustom, ImportFileUpload } from "../../shared/Style/Style";
import { BundlesBlock } from "../styles";
import { TrainerContext } from "../context";

export const TrainerBundlesBlock = (
    { onDeleteFile }: { onDeleteFile: (key: string) => void }
) => { 
    const iosInput = useRef<HTMLInputElement | null>(null);
    const androidInput = useRef<HTMLInputElement | null>(null);
    const webGlInput = useRef<HTMLInputElement | null>(null);
    const manifestInputIos = useRef<HTMLInputElement | null>(null);
    const manifestInputAndroid = useRef<HTMLInputElement | null>(null);
    const webGlManifestInput = useRef<HTMLInputElement | null>(null);

    const bundlesData = [
        {
            key: "iosBundle",
            label: "Ios Bundle",
            inputRef: iosInput,
        },
        {
            key: "androidBundle",
            label: "Android Bundle",
            inputRef: androidInput,
        },
        {
            key: "webGlBundle",
            label: "WebGL Bundle",
            inputRef: webGlInput,
        },
        {
            key: "iosManifest",
            label: "Ios Manifest",
            inputRef: manifestInputIos,
        },
        {
            key: "androidManifest",
            label: "Android Manifest",
            inputRef: manifestInputAndroid,
        },
        {
            key: "webGlManifest",
            label: "WebGL Manifest",
            inputRef: webGlManifestInput,
        },
    ];

    const uploadBundleHandler = (file: File, callback: (file: File) => void) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            callback(file);
        };
        reader.readAsDataURL(file);
    };

    const renderCurrentBundle = (
        key: string,
        label: string,
        bundleUrl: string,
        inputRef: React.RefObject<HTMLInputElement>,
        updateTrainerData: (key: string, value: File) => void,
    ) => {
        return (
            <BundleContainer key={key}>
                <BundleName>{label}</BundleName>
                {bundleUrl ? (
                    <div key={key}>
                        <BundleLink href={bundleUrl}>файл завантажений</BundleLink>
                        <IconButton
                            onClick={() => {
                                onDeleteFile(key);
                                updateTrainerData(key, null);
                            }}
                        >
                            <ClearIcon color="error" fontSize="small" />
                        </IconButton>
                    </div>
                ) : (
                      <ButtonCustom onClick={() => inputRef.current.click()}>
                      <span>Прикріпити</span>
                      <ImportFileUpload
                        key={key}
                        type="file"
                        accept={label.includes("Manifest") && ".manifest"}    
                        ref={inputRef}
                        onChange={({ target: { files } }) =>
                            files[0] && uploadBundleHandler(files[0], (file) => {
                                updateTrainerData(key, file);
                            })
                        }
                      />
                    </ButtonCustom>                         
                )}

            </BundleContainer>
        );
    };
    
    return (
        <TrainerContext.Consumer>
            {({ data, updateTrainerData }) => (
                <BundlesBlock >
                    <h2>Bundles *</h2>
                    {bundlesData.map(({
                        key, label, inputRef
                    }) =>
                        renderCurrentBundle(
                            key,
                            label,
                            data[key],
                            inputRef,
                            updateTrainerData,
                        ))
                    }
                </BundlesBlock >
            )}
        </TrainerContext.Consumer>
    );
};
